export const taskStateTranslations = {
  PENDING: 'En attente',
  AWAITING_CUSTOMER: 'En attente du client',
  RESOLVED: 'Résolu',
  REJECTED: 'Rejeté',
};
